import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import wrapReact from '../react';

const NewRoutes = (p) => {
  const { routes, className } = p;
  if (routes) {
    return (
      <div
        className={className}
        style={{ display: 'flex', height: 'inherit', width: 'inherit' }}
      >
        <Switch>
          {routes.map(route => (route.exact ? (
            <Route
              key={route.path}
              render={
                  route.redirect
                    ? () => <Redirect to={route.redirect} />
                    : props => (
                      <route.component
                        {...props}
                        {...p}
                        className={undefined}
                        filePath={undefined}
                        routes={route.routes}
                      />
                    )
                }
              exact
              path={route.path}

            />
          ) : (
            <Route
              render={
                  route.redirect
                    ? () => <Redirect to={route.redirect} />
                    : props => (
                      <route.component
                        {...props}
                        {...p}
                        className={undefined}
                        filePath={undefined}
                        routes={route.routes}
                      />
                    )
                }
              key={route.path}
              path={route.path}
            />
          )))}
        </Switch>
      </div>
    );
  }
  return null;
};

export const Routes = wrapReact(NewRoutes, 'util_router_Routes', {
  intl: false,
});
